export default __webpack_public_path__ + "static/FuturaLT-CondensedExtraBold-0097c92e6c9bf11434c64b1013fa3b04.ttf";